import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Befundmitteilung, BefundmitteilungAllDownload } from './befundmitteilung';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { HttpParams } from '@angular/common/http';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Gruppe } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import {
    ActionTableColumn,
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    EmailGesendetTableColumn,
    PdfTableColumn,
    TextTableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { FileUploadService } from '../../dialogs/file-upload-dialog/file-upload.service';
import { FileDownloadService } from '../../services/file-download.service';
import { BefundmitteilungService } from './befundmitteilung.service';
import { Untersuchungsmaterial } from '../untersuchungsmaterialien/untersuchungsmaterial';
import {
    MaterialienFilterDialogComponent,
    MaterialienFilterDialogResult,
} from './materialien-filter-dialog/materialien-filter-dialog.component';
import { DateRange } from '../date-range';
import {
    DateRangeDialogComponent,
    DateRangeDialogInput,
} from '../../dialogs/date-range-dialog/date-range-dialog.component';
import { SelectBefundKategorieDialogComponent } from './select-befund-kategorie-dialog/select-befund-kategorie-dialog.component';

@Component({
    selector: 'kiene-befundmitteilung',
    templateUrl: './befundmitteilung.component.html',
    styleUrls: ['./befundmitteilung.component.scss'],
})
export class BefundmitteilungComponent implements OnInit, OnDestroy {
    tableDescriptor: TableDescriptor = new TableDescriptor();
    public nichtAbgeschlossenCount = 0;
    selectedMaterialien: Untersuchungsmaterial[] = [];

    dateRange: DateRange;

    watchClientSubscription: Subscription;
    currentClient: Client;

    constructor(
        public dialog: MatDialog,
        private tableService: KieneTableService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly localStorageService: LocalStorageService,
        private readonly befundmitteilungService: BefundmitteilungService,
        private readonly pdfViewerService: PdfViewerDesktopService,
        private readonly fileUploadService: FileUploadService,
        private readonly fileDownloadService: FileDownloadService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {
        this.currentClient = this.localStorageService.getCurrentClient();
    }

    ngOnDestroy() {
        this.watchClientSubscription.unsubscribe();
        this.tableService = null;
    }

    ngOnInit() {
        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe(client => {
            this.currentClient = client;
            this.tableService?.reload();
        });
        this.tableDescriptor.headline = 'Befundmitteilungen';
        this.tableDescriptor.uniqueIdentifier = 'Befundmitteilungen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'befund/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.nameOfIdField = 'befund_id';
        this.tableDescriptor.sendCurrentClient = true;

        if (this.router.url.startsWith('/belege')) {
            this.tableDescriptor.detailsRoute = '/belege/labor/befundmitteilungen/';
            this.tableDescriptor.sendCurrentClient = true;
        } else {
            this.tableDescriptor.detailsRoute = '/labor/befundmitteilungen/';
        }

        this.tableDescriptor.columns = this.getTableColumns();
        this.tableDescriptor.options = this.getTableOptions();
        this.tableDescriptor.filterItems = this.getFilterItems();

        this.tableDescriptor.addToolbarButton(
            new ToolbarButton(
                this.openUntersuchungsMaterialienFilterDialog.bind(this),
                'filter_alt',
                2605,
                'Untersuchungsmaterialien filtern',
            ),
        );
        this.tableDescriptor.addToolbarButton(
            new ToolbarButton(this.openDateRangeDialog.bind(this), 'date_range', 1311, 'Zeitraum filtern'),
        );

        this.tableDescriptor.permissionView = 1311;
        this.tableDescriptor.permissionCreate = 1312;
        this.tableDescriptor.skipOptionsTablePadding = true;

        this.tableDescriptor.initialSortColumn = 'tagebuch_nr';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.addVoid = this.openNewBefundmitteilung.bind(this);

        this.readSpeicher();
        this.getNichtAbgeschlossenCount();
    }

    private getNichtAbgeschlossenCount(): void {
        let params: HttpParams = new HttpParams().set('status_id', 11).set('limit', 1);
        this.api.getAll(this.apiBaseUrl + 'befund/read.php', params).subscribe({
            next: value => {
                this.nichtAbgeschlossenCount = value.count;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Abrufen der Belege!', err);
            },
        });
    }

    getFilterItems() {
        const items = [];
        items.push(new FilterItem('Befund nicht abgerechnet', '0', FilterItemType.CHECKBOX, 'rechnung', false));
        if (this.localStorageService.getCurrentUser()?.tierarzt_id) {
            items.push(
                new FilterItem('Nur meine Tierarztgruppe', '1', FilterItemType.CHECKBOX, 'meinetierarztgruppen', true),
            );
        }
        items.push(new FilterItem('Befund erstellt', '11', FilterItemType.CHECKBOX, 'status_id', false));
        items.push(new FilterItem('Befund abgeschlossen', '12', FilterItemType.CHECKBOX, 'status_id', false));
        items.push(new FilterItem('Befund freigegeben', '13', FilterItemType.CHECKBOX, 'status_id', false));
        items.push(new FilterItem('Befund storniert', '14', FilterItemType.CHECKBOX, 'status_id', false));
        items.push(new FilterItem('Befund wird korrigiert', '15', FilterItemType.CHECKBOX, 'status_id', false));
        return items;
    }

    getTableColumns() {
        const columns = [];
        columns.push(
            new TextTableColumn('tagebuch_nr', 'Tagebuchnummer', {
                sortFields: ['befundjahr', 'befundnummer', 'befund_id'],
                maxWidth: '15ch',
                maxLength: 14,
            }),
        );
        columns.push(
            new TextTableColumn('untersuchungsmaterial', 'Untersuchungsmaterial', {
                maxWidth: '36ch',
                maxLength: 42,
            }),
        );
        columns.push(
            new TextTableColumn('tierarztgruppe', 'Tierarztgruppe', {
                maxWidth: '10ch',
                maxLength: 10,
            }),
        );
        columns.push(
            new TextTableColumn('kunde', 'Kunde', {
                maxWidth: '28ch',
                maxLength: 32,
            }),
        );
        columns.push(
            new TextTableColumn('zusatz', 'Zusatz', {
                maxWidth: '20ch',
                maxLength: 24,
            }),
        );
        columns.push(
            new TextTableColumn('gruppe', 'Gruppe', {
                maxWidth: '14ch',
                maxLength: 16,
            }),
        );
        columns.push(new DateTableColumn('eingang', 'Untersuchungsbeginn', 'dd.MM.yyyy'));
        columns.push(new DateTableColumn('ausgang', 'Untersuchungsende', 'dd.MM.yyyy'));
        const statusConditions = [];
        statusConditions.push(
            new ConditionSetting([new Condition('status_id', Operator.GLEICH, 11)], { icon: 'fiber_new' }),
        );
        statusConditions.push(
            new ConditionSetting([new Condition('status_id', Operator.GLEICH, 12)], { icon: 'lock' }),
        );
        statusConditions.push(
            new ConditionSetting([new Condition('status_id', Operator.GLEICH, 13)], { icon: 'done' }),
        );
        statusConditions.push(
            new ConditionSetting([new Condition('status_id', Operator.GLEICH, 14)], { icon: 'cancel' }),
        );
        statusConditions.push(
            new ConditionSetting([new Condition('status_id', Operator.GLEICH, 15)], { icon: 'edit' }),
        );
        columns.push(new ConditionTableColumn('status_id', 'Status', statusConditions));
        columns.push(
            new ActionTableColumn(
                'rechnung',
                '$',
                'Rechnung anzeigen',
                'attach_money',
                this.openInvoice.bind(this),
                null,
                1320,
                [new ConditionSetting([new Condition('rechnung_id', Operator.EXISTIERT, null)])],
            ),
        );
        columns.push(new DateTableColumn('erstellt', 'Erstellt', 'dd.MM.yyyy HH:mm'));
        columns.push(new PdfTableColumn('pdf_id', 'PDF', this.downloadAllPdfsForBefundmitteilungMerged.bind(this)));
        columns.push(new EmailGesendetTableColumn());
        // columns.push( new GedrucktTableColumn() );

        const conditionBefundeExtern = [];
        conditionBefundeExtern.push(
            new ConditionSetting([new Condition('befunde_extern', Operator.GROESSER, 0)], { icon: 'attach_file' }),
        );
        columns.push(new ConditionTableColumn('befunde_extern', 'E', conditionBefundeExtern));
        return columns;
    }

    getTableOptions() {
        const options = [];
        options.push(
            new TableOption(this.transformToAntibiogramm.bind(this), 'In Antibiogramm umwandeln', 'swap_horiz', 1336, {
                conditions: [new Condition('antibiogramm_id', Operator.EXISTIERT_NICHT, undefined)],
            }),
        );
        options.push(
            new TableOption(
                this.transformToUntersuchungsauftrag.bind(this),
                'Untersuchungsauftrag generieren',
                'swap_horiz',
                1337,
            ),
        );
        options.push(
            new TableOption(this.goToAntibiogramme.bind(this), 'Antibiogramme anzeigen', 'play_arrow', 1811, {
                conditions: [new Condition('antibiogramme', Operator.GROESSER, 0)],
            }),
        );
        options.push(
            new TableOption(
                this.goToUntersuchungsauftraege.bind(this),
                'Untersuchungsaufträge anzeigen',
                'play_arrow',
                2511,
                { conditions: [new Condition('untersuchungsauftraege', Operator.GROESSER, 0)] },
            ),
        );
        options.push(new TableOption(this.openAddExternalPdfsDialog.bind(this), 'PDFs hinzufügen', 'forward', 1322));
        options.push(new TableOption(this.openPdf.bind(this), 'Befund einzeln herunterladen', 'save_alt', 1317));
        options.push(
            new TableOption(this.openConfirmDeleteBefundmitteilungDialog.bind(this), 'Befund löschen', 'delete', 1314),
        );
        options.push(new TableOption(this.openInvoice.bind(this), 'Rechnung anzeigen', 'attach_money', 1320));
        options.push(
            new TableOption(this.rechnungAnzeigen.bind(this), 'zu Rechnung springen', 'attach_money', 2971, {
                conditions: [new Condition('rechnung_id', Operator.EXISTIERT, undefined)],
            }),
        );
        options.push(new TableOption(this.recreateBefund.bind(this), 'Befund PDF neu erstellen', 'replay', 1308));
        options.push(new TableOption(this.befundDuplizieren.bind(this), 'Befund duplizieren', 'file_copy', 1338));
        options.push(new TableOption(this.createNotiz.bind(this), 'Notizzettel erstellen', 'note_add', 2605));
        options.push(
            new TableOption(this.cancelBefund.bind(this), 'Befund stornieren', 'cancel', 1329, {
                conditions: [new Condition('status_id', Operator.GLEICH, 12)],
            }),
        );
        options.push(
            new TableOption(this.reOpenBefund.bind(this), 'Befund wieder öffnen', 'lock_open', 1309, {
                conditions: [new Condition('status_id', Operator.GLEICH, 12)],
            }),
        );
        options.push(
            new TableOption(this.exportIdexxTestlauf.bind(this), 'Idexx Positionen exportieren', 'file_upload', 1339, {
                conditions: [new Condition('idexx', Operator.GROESSER, 0)],
            }),
        );

        return options;
    }

    gedruckt(befund: Befundmitteilung) {
        this.api
            .get(this.apiBaseUrl + 'befund/gedruckt.php', new HttpParams().set('befund_id', befund.befund_id))
            .subscribe({
                next: () => {
                    this.tableService.reload('gedruckt');
                    this.openPdf(befund);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    transformToAntibiogramm(b: Befundmitteilung) {
        this.api.post(this.apiBaseUrl + 'antibiogramm/transform.php', b, null).subscribe({
            next: response => {
                this.router.navigate(['../antibiogramme', response.antibiogramm_id], { relativeTo: this.route }).then();
            },
            error: error => {
                this.messageService.errorMessage('Antibiogramm konnte nicht erstellt werden! ', error);
            },
        });
    }

    goToAntibiogramme(b: Befundmitteilung) {
        this.router
            .navigate(['../antibiogramme'], {
                relativeTo: this.route,
                queryParams: { befund_id: b.befund_id, clearsearch: true },
            })
            .then();
    }

    goToUntersuchungsauftraege(b: Befundmitteilung) {
        this.router
            .navigate(['../untersuchungsauftrag'], {
                relativeTo: this.route,
                queryParams: { befund_id: b.befund_id, clearsearch: true },
            })
            .then();
    }

    transformToUntersuchungsauftrag(b: Befundmitteilung) {
        this.api.post(this.apiBaseUrl + 'untersuchungsauftrag/transform.php', b, null).subscribe(
            response => {
                this.router
                    .navigate(['../untersuchungsauftrag', response.untersuchungsauftrag_id], { relativeTo: this.route })
                    .then();
            },
            error => {
                this.messageService.errorMessage('Es konnte kein Untersuchungsauftrag generiert werden! ', error);
            },
        );
    }

    openConfirmDeleteBefundmitteilungDialog(row: Befundmitteilung) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '350px',
            data: {
                title: 'Befundmitteilung löschen',
                text: 'Wollen Sie die Befundmitteilung ' + row.tagebuch_nr + ' wirklich löschen?',
                textButton: 'Löschen',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteBefundmitteilung(row);
            }
        });
    }

    deleteBefundmitteilung(befundmitteilung: Befundmitteilung) {
        this.befundmitteilungService.deleteBefundmitteilung(befundmitteilung).subscribe({
            next: () => {
                this.messageService.infoMessage(
                    'Befundmitteilung: ' + befundmitteilung.tagebuch_nr + ' erfolgreich entfernt!',
                );
                this.tableService.reload('deleteBefundmitteilung');
            },
            error: error => {
                console.error(error);
                this.messageService.errorMessage(
                    'Löschen von Befundmitteilung: ' + befundmitteilung.tagebuch_nr + ' ist fehlgeschlagen!',
                    error,
                );
            },
        });
    }

    openNewBefundmitteilung() {
        this.dialog
            .open(SelectBefundKategorieDialogComponent, {})
            .afterClosed()
            .subscribe({
                next: kategorie => {
                    if (kategorie) {
                        this.router
                            .navigate(['neu'], { queryParams: { kategorie: kategorie }, relativeTo: this.route })
                            .then();
                    }
                },
            });
    }

    createNotiz(b: Befundmitteilung) {
        this.befundmitteilungService.getNotizzettel(b);
    }

    reOpenBefund(b: Befundmitteilung) {
        this.api.post(this.apiBaseUrl + 'befund/korrigieren.php', b, null).subscribe({
            next: () => {
                this.messageService.infoMessage('Befund ' + b.tagebuch_nr + ' wurde wieder geöffnet');
                this.tableService.reload('reOpenBefund');
            },
            error: err => {
                this.messageService.errorMessage(
                    'Befund ' + b.tagebuch_nr + ' konnte nicht wieder geöffnet werden. ',
                    err,
                );
            },
        });
    }

    befundDuplizieren(b) {
        const input = new ConfirmDialogInput();
        input.headline = 'Befundmitteilung duplizieren';
        input.text = 'Wollen Sie die Befundmitteilung duplizieren?';
        input.okButton = 'duplizieren';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });
        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.api.post(this.apiBaseUrl + 'befund/duplizieren.php', b, undefined).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Der Befund wurde erfolgreich dupliziert!');
                            this.tableService.reload('reOpenBefund');
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler beim Duplizieren!', err);
                            this.tableService.reload('reOpenBefund');
                        },
                    });
                }
            },
        });
    }

    downloadAllPdfsForBefundmitteilungMerged(befundmitteilung: Befundmitteilung) {
        const input = new PdfViewerDialogInput(
            'befund/read_or_mail_pdf_merged.php',
            new HttpParams().set('befund_id', befundmitteilung?.befund_id?.toString()),
            this.befundmitteilungService.getPdfTitle(befundmitteilung),
            this.befundmitteilungService.getPdfViewerEmailOptions(befundmitteilung),
        );
        this.pdfViewerService.openPdfViewer(input).subscribe({
            next: () => {
                this.tableService.reload('downloadAllPdfsForBefundmitteilungMerged');
            },
        });
    }

    openAddExternalPdfsDialog(befundmitteilung: Befundmitteilung) {
        this.fileUploadService.openAddFilesDialog(
            befundmitteilung.befund_id,
            'befund_id',
            'befund_dokument/create_extern.php',
            () => {
                this.tableService.reload('openAddExternalPdfsDialog');
            },
            () => {},
        );
    }

    openPdf(befundmitteilung: Befundmitteilung) {
        const pdfId = befundmitteilung.pdf_id;
        if (pdfId) {
            const input = new PdfViewerDialogInput(
                'befund/read_or_mail_pdf.php',
                new HttpParams().set('befund_id', befundmitteilung?.befund_id?.toString()),
                this.befundmitteilungService.getPdfTitle(befundmitteilung),
                this.befundmitteilungService.getPdfViewerEmailOptions(befundmitteilung),
            );
            this.pdfViewerService.openPdfViewer(input); // super
        }
    }

    openInvoice(befundmitteilung: Befundmitteilung) {
        const title: string = 'Rechnung Befundmitteilung ' + befundmitteilung.tagebuch_nr;

        const input = new PdfViewerDialogInput(
            'befund/read_rechnung.php',
            new HttpParams().append('befund_id', befundmitteilung?.befund_id?.toString()),
            title,
        );
        this.pdfViewerService.openPdfViewer(input); // super
    }

    rechnungAnzeigen(b: Befundmitteilung) {
        this.router.navigate(['/finanzen', 'rechnungen', b.rechnung_id]).then();
    }

    cancelBefund(b: Befundmitteilung) {
        this.api.post(this.apiBaseUrl + 'befund/stornieren.php', b, null).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Bufund wurde storniert!');
                this.tableService.reload('cancelBefund');
            },
            error: err => {
                this.messageService.errorMessage('Der Befund konnte nicht storniert werden!', err);
            },
        });
    }

    recreateBefund(befundmitteilung: Befundmitteilung) {
        this.befundmitteilungService.recreateBefund(befundmitteilung).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Befund PDF ' + befundmitteilung.tagebuch_nr + ' erfolgreich neu erstellt!',
                );
                this.tableService.reload('recreateBefund');
            },
            error => {
                console.error(error);
                this.messageService.errorMessage('Fehler ' + befundmitteilung.tagebuch_nr + '!', error);
            },
        );
    }

    uploadExterneBefundmitteilung(files: File[], befundmitteilung: Befundmitteilung) {
        this.fileUploadService.uploadFilesToServer(
            files,
            'befund_id',
            befundmitteilung.befund_id,
            'befund_dokument/create_extern.php',
        );
        this.fileUploadService.watchFileUploaded().subscribe(fileName => {
            for (const f of files) {
                if (f.name === fileName) {
                    this.tableService.reload('uploadExterneBefundmitteilung');
                }
            }
        });
    }

    exportIdexxTestlauf(row: Befundmitteilung) {
        const idsToExport: number[] = [];
        row.positionen.forEach(position => {
            if (Number(position.idexx) === 1) {
                idsToExport.push(position.ba_id);
            }
        });

        let httpParams = new HttpParams();
        httpParams = httpParams.set('ba_ids', idsToExport.toString());
        this.fileDownloadService.downloadCSV('idexx_testlauf/create_csv_one.php', httpParams).subscribe({
            next: size => {
                if (size <= 0) {
                    this.messageService.infoMessage(
                        'Alle Idexx-Testläufe der Befundmitteilung sind bereits exportiert und abgeschlossen!',
                    );
                }
            },
            error: error => {
                this.messageService.errorMessage('Fehler!', error);
            },
        });
    }

    private openUntersuchungsMaterialienFilterDialog(): void {
        this.dialog
            .open(MaterialienFilterDialogComponent, { minWidth: '600px', data: this.selectedMaterialien })
            .afterClosed()
            .subscribe({
                next: (result: MaterialienFilterDialogResult) => {
                    if (result?.confirm) {
                        this.api.setSpeicher('untersuchungsmaterialien', result.selectedMaterialien ?? []).subscribe({
                            next: saved => {
                                if (saved) {
                                    if (
                                        result.selectedMaterialien === undefined ||
                                        result.selectedMaterialien.length === 0
                                    ) {
                                        this.tableDescriptor.params =
                                            this.tableDescriptor.params.delete('untersuchungsmaterial_id[]');
                                    } else {
                                        if (!this.tableDescriptor.params) {
                                            this.tableDescriptor.params = new HttpParams();
                                        }
                                        for (const m of result.selectedMaterialien) {
                                            this.tableDescriptor.params = this.tableDescriptor.params.append(
                                                'untersuchungsmaterial_id[]',
                                                m.untersuchungsmaterial_id,
                                            );
                                        }
                                    }
                                    this.selectedMaterialien = result.selectedMaterialien;
                                    this.tableService?.reload('openUntersuchungsMaterialienFilterDialog');
                                }
                            },
                            error: error => {
                                this.messageService.errorMessage(
                                    'Fehler beim Speichern der Untersuchungsmaterialien',
                                    error,
                                );
                            },
                        });
                    }
                },
            });
    }

    private ladeMaterialienSpeicher2(): void {
        this.api.getSpeicher('untersuchungsmaterialien').subscribe({
            next: response => {
                if (response) {
                    this.selectedMaterialien = response;
                    if (!this.tableDescriptor.params) {
                        this.tableDescriptor.params = new HttpParams();
                    }
                    for (const m of this.selectedMaterialien) {
                        this.tableDescriptor.params = this.tableDescriptor.params.append(
                            'untersuchungsmaterial_id[]',
                            m.untersuchungsmaterial_id,
                        );
                    }
                    this.tableService?.reload('ladeMaterialienSpeicher');
                }
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Untersuchungsmaterialien', error);
            },
        });
    }

    openDateRangeDialog() {
        const dateRangeInput = new DateRangeDialogInput();
        dateRangeInput.title = 'Zeitraum filtern';
        dateRangeInput.zeit_von = this.dateRange?.zeit_von;
        dateRangeInput.zeit_bis = this.dateRange?.zeit_bis;

        const dialogRef = this.dialog.open(DateRangeDialogComponent, { data: dateRangeInput });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.confirm) {
                if (!this.tableDescriptor.params) {
                    this.tableDescriptor.params = new HttpParams();
                }
                this.dateRange = result?.range;

                if (this.dateRange) {
                    this.api.setSpeicher('befunde_date_range', this.dateRange).subscribe({
                        next: () => {
                            this.setParamZeitVon();
                            this.setParamZeitBis();
                            this.tableService.reload('befunde_date_range');
                        },
                        error: error => {
                            console.error(error);
                            this.messageService.errorMessage('Fehler beim Speichern des Zeitraums!', error);
                        },
                    });
                }
            }
        });
    }

    private setParamZeitBis(): void {
        if (this.dateRange?.zeit_bis) {
            this.dateRange.zeit_bis = new Date(this.dateRange.zeit_bis);
            this.dateRange.zeit_bis.setHours(23, 59, 59, 999);
            this.tableDescriptor.params = this.tableDescriptor.params.set(
                'erstellt_bis',
                this.dateRange?.zeit_bis?.toISOString(),
            );
        } else {
            this.tableDescriptor.params = this.tableDescriptor.params.delete('erstellt_bis');
        }
    }

    private setParamZeitVon(): void {
        if (this.dateRange?.zeit_von) {
            this.dateRange.zeit_von = new Date(this.dateRange.zeit_von);
            this.dateRange.zeit_von.setHours(0, 0, 0, 0);
            this.tableDescriptor.params = this.tableDescriptor.params.set(
                'erstellt_von',
                this.dateRange?.zeit_von?.toISOString(),
            );
        } else {
            this.tableDescriptor.params = this.tableDescriptor.params.delete('erstellt_von');
        }
    }

    readSpeicher() {
        if (!this.tableDescriptor.params) {
            this.tableDescriptor.params = new HttpParams();
        }
        this.api.getSpeicher('befunde_date_range').subscribe({
            next: result => {
                this.dateRange = result;
                this.setParamZeitVon();
                this.setParamZeitBis();
                this.ladeMaterialienSpeicher2();
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden des Zeitraums!', error);
                this.ladeMaterialienSpeicher2();
            },
        });
    }

    resetDateRangeFilter() {
        this.dateRange = new DateRange();
        this.api.setSpeicher('befunde_date_range', this.dateRange).subscribe({
            next: () => {
                this.setParamZeitVon();
                this.setParamZeitBis();
                this.tableService.reload('befunde_date_range');
            },
            error: error => {
                console.error(error);
                this.messageService.errorMessage('Fehler beim Speichern des Zeitraums!', error);
            },
        });
    }

    removeSelectedMaterial(m: Untersuchungsmaterial) {
        const index = this.selectedMaterialien.findIndex(entry =>
            KieneUtils.sameId(entry.untersuchungsmaterial_id, m.untersuchungsmaterial_id),
        );
        if (index >= 0) {
            this.selectedMaterialien.splice(index, 1);
        }
        this.api.setSpeicher('untersuchungsmaterialien', this.selectedMaterialien).subscribe({
            next: () => {
                if (!this.tableDescriptor.params) {
                    this.tableDescriptor.params = new HttpParams();
                }
                this.tableDescriptor.params = this.tableDescriptor.params.delete('untersuchungsmaterial_id[]');
                for (const material of this.selectedMaterialien) {
                    this.tableDescriptor.params = this.tableDescriptor.params.append(
                        'untersuchungsmaterial_id[]',
                        material.untersuchungsmaterial_id,
                    );
                }
                this.tableService?.reload('removeSelectedMaterial');
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Speichern der Untersuchungsmaterialien', error);
            },
        });
    }
}

@Component({
    selector: 'befundmitteilung-new-note-dialog',
    template: `<h3 mat-dialog-title>Neue Befundmitteilungnotiz</h3>
        <mat-dialog-content>
            <p>Bitte Betrieb ausw&auml;hlen</p>
            <kiene-client-group-autocomplete
                [showInactiveToggle]="true"
                (selectedGroup)="setSelectedGroup($event)"
            ></kiene-client-group-autocomplete>
            <p>Bitte die Tagebuchnummer eingeben</p>
            <mat-form-field>
                <input
                    matInput
                    name="tagebuchnummer"
                    placeholder="Tagebuchnummer"
                    [(ngModel)]="tagebuchnummer"
                    (keyup.enter)="createBefundmitteilungNote()"
                />
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
            <button mat-button color="primary" (click)="createBefundmitteilungNote()">Erstellen</button>
        </mat-dialog-actions>`,
})
export class BefundmitteilungNewNoteDialog {
    tagebuchnummer: string;
    client: Client;
    clientGroup: Gruppe;

    constructor(
        public dialogRef: MatDialogRef<BefundmitteilungNewNoteDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    setCurrentClient(client: Client) {
        this.client = client;
    }

    setSelectedGroup(clientGroup: Gruppe) {
        this.clientGroup = clientGroup;
    }

    createBefundmitteilungNote() {
        const note = { tagebuchnummer: this.tagebuchnummer, client: this.client, clientGroup: this.clientGroup };
        this.dialogRef.close(note);
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}

@Component({
    selector: 'befundmitteilung-new-sample-sheet-dialog',
    template: `<h3 mat-dialog-title>Neuer Probenbegleitschein</h3>
        <mat-dialog-content>
            <p>Bitte Betrieb ausw&auml;hlen</p>
            <kiene-client-group-autocomplete
                [showInactiveToggle]="true"
                (selectedGroup)="setSelectedGroup($event)"
            ></kiene-client-group-autocomplete>
            <p>Bitte Probenentnahmedatum eingeben</p>
            <mat-form-field style="margin-right: 10px; min-width: 10%;">
                <input
                    matInput
                    [matDatepicker]="probenentnahmePicker"
                    placeholder="Probenentnahmedatum"
                    [(ngModel)]="probenentnahme"
                />
                <mat-datepicker-toggle matSuffix [for]="probenentnahmePicker"></mat-datepicker-toggle>
                <mat-datepicker #probenentnahmePicker></mat-datepicker>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
            <button mat-button color="primary" (click)="createBefundmitteilungSampleSheet()">Erstellen</button>
        </mat-dialog-actions>`,
})
export class BefundmitteilungNewSampleSheetDialog {
    client: Client;
    clientGroup: Gruppe;
    probenentnahme: Date = new Date();

    constructor(
        public dialogRef: MatDialogRef<BefundmitteilungNewNoteDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    setCurrentClient(client: Client) {
        this.client = client;
    }

    setSelectedGroup(clientGroup: Gruppe) {
        this.clientGroup = clientGroup;
    }

    createBefundmitteilungSampleSheet() {
        const sampleSheet = { client: this.client, clientGroup: this.clientGroup, probenentnahme: this.probenentnahme };
        this.dialogRef.close(sampleSheet);
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}

@Component({
    selector: 'download-all-befundmitteilung-dialog',
    template: `<h3 mat-dialog-title>Alle Befunde zu einem Betrieb herunterladen</h3>
        <mat-dialog-content>
            <h5>Betrieb ausw&auml;hlen</h5>
            <kiene-client-autocomplete
                (selectedClient)="setSelectedClient($event)"
                [panelWidth]="'50%'"
                [showInactiveToggle]="true"
            ></kiene-client-autocomplete>
            <mat-divider></mat-divider>
            <h5>Zeitraum angeben (Probenentnahme)</h5>

            <mat-form-field style="min-width: 40%; padding-left: 10px;">
                <input
                    matInput
                    [matDatepicker]="fromPicker"
                    placeholder="Von"
                    [(ngModel)]="befundmitteilungAllDownload.zeit_von"
                />
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field style="min-width: 40%; padding-left: 10px;">
                <input
                    matInput
                    [matDatepicker]="toPicker"
                    placeholder="Bis"
                    [(ngModel)]="befundmitteilungAllDownload.zeit_bis"
                />
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button color="primary" (click)="onCancelClick()">Abbrechen</button>
            <button mat-raised-button color="primary" (click)="closeDialog()">Herunterladen</button>
        </mat-dialog-actions>`,
})
export class DownloadAllBefundmitteilungDialog implements OnInit {
    befundmitteilungAllDownload: BefundmitteilungAllDownload = new BefundmitteilungAllDownload();

    gruppeFormCtrl: UntypedFormControl = new UntypedFormControl();
    gruppen: Observable<Gruppe[]>;
    client: Client;

    constructor(
        private gruppenService: GruppenService,
        public dialogRef: MatDialogRef<DownloadAllBefundmitteilungDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        this.autocompleteGruppen();
    }

    setSelectedClient(c: Client) {
        this.client = c;
    }

    closeDialog() {
        this.befundmitteilungAllDownload.client = this.client;
        this.dialogRef.close(this.befundmitteilungAllDownload);
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    autocompleteGruppen() {
        this.gruppeFormCtrl = new UntypedFormControl();
        this.gruppen = this.gruppeFormCtrl.valueChanges.pipe(
            startWith(''),
            switchMap(value => this.searchGruppen(value)),
        );
    }

    searchGruppen(value: string) {
        return this.gruppenService.searchGruppenPraxissoftware(value).pipe(
            debounceTime(300),
            distinctUntilChanged(),
            map(response => response.records),
        );
    }
}

@Component({
    selector: 'download-file-info-dialog',
    template: ` <h3 mat-dialog-title>
            <mat-icon color="primary">info</mat-icon>
            Download Info
        </h3>
        <mat-dialog-content>
            Die Datei
            <span style="font-style: italic">{{ data.dateiname }}.pdf</span>
            wird heruntergeladen...
            <br />
            <br />
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <br />
        </mat-dialog-content>`,
})
export class DownloadFileInfoDialog {
    constructor(
        public dialogRef: MatDialogRef<DownloadFileInfoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}
